import React from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { msalInstance } from '@sib/auth';
import { env } from '@sib/config';
import { tracking } from '@sib/tracking';
import { updateUserId } from './common/utils';
import './config/i18n';
import App from './core/App';

tracking.init();

Sentry.init({
  dsn: env.spendbrainSentryDSN,
  environment: env.spendbrainEnv,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracePropagationTargets: [
    'localhost',
    'sib.spenndbrain.ai',
    'staging-microsites.spendbrain.ai',
    'dev.microsites.aboutsib.com',
    env.apiBaseUrl,
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const container = document.getElementById('root');
const root = createRoot(container!);

msalInstance.initialize().then(() => {
  updateUserId();

  root.render(
    <React.StrictMode>
      <React.Suspense>
        <App />
      </React.Suspense>
    </React.StrictMode>
  );
});
